import { Component, Inject, OnInit, Optional } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { PhiTimerService } from "src/app/services/phi-timer.service";
import { PhiSecurityService } from "src/app/services/phi-security.service";
import { ApiService } from "src/app/services/api.service";
import { FilterService } from "../../../services/filter.service";
import { SessionService } from "../../../services/session.service";

@Component({
  selector: "app-login-popup",
  templateUrl: "./login-popup.component.html",
  styleUrls: ["./login-popup.component.scss"],
})
export class LoginPopupComponent implements OnInit {
  // Single master consent checkbox
  consentAgreed: boolean = false;

  // Dialog mode: 'consent' for PHI consent, 'notification' for timeout notification
  mode: "consent" | "notification" = "consent";
  notificationMessage: string = "";

  // View state within consent mode
  viewState: "consent" | "success" | "declined" = "consent";

  // Flag that becomes true when the circular border animation completes
  borderLoadComplete: boolean = false;

  // Loading state while API call is in progress
  isSubmitting: boolean = false;

  // Current timestamp
  currentTimestamp: string = "";

  // Agreed timestamp for success state
  agreedTimestamp: string = "";

  constructor(
    @Optional() public dialogRef: MatDialogRef<LoginPopupComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private phiTimerService: PhiTimerService,
    private filterService: FilterService,
    private sessionService: SessionService,
    private apiService: ApiService
  ) {}

  ngOnInit(): void {
    if (this.data?.mode === "notification") {
      this.mode = "notification";
      this.notificationMessage = this.data?.message || "";
    }
    this.updateTimestamp();
  }

  get allConsentsChecked(): boolean {
    return this.consentAgreed;
  }

  agree(): void {
    if (!this.allConsentsChecked || this.isSubmitting) return;

    this.isSubmitting = true;
    const consentDate = this.formatTimestamp();

    const payload = {
      phi_access_consent_flag: "Y",
      consent_date: consentDate,
    };
    
    // API success — show success state with animated border
    let obj = Object.assign({}, (this.filterService.baseQuery || {}), payload, {'user_id': this.sessionService.getUsername()});
    this.apiService.post("api/update-phi-consent", obj).subscribe(
      (response: any) => {
        
        this.isSubmitting = false;
        this.agreedTimestamp = consentDate;
        this.filterService.phiAccessConsentFlag = 'Y'
        this.viewState = "success";
        this.borderLoadComplete = false;
      },
      (error: any) => {
        this.isSubmitting = false;
        this.viewState = "consent";
      }
    );
  }

  onBorderAnimationComplete(): void {
    this.borderLoadComplete = true;
    // Auto-close after border animation finishes
    setTimeout(() => {
      if (this.dialogRef) {
        this.dialogRef.close({ success: true });
      }
    }, 100);
  }

  decline(): void {
    this.viewState = "declined";
  }

  handleReview(): void {
    this.consentAgreed = false;
    this.viewState = "consent";
  }

  closeDialog(): void {
    if (this.dialogRef) {
      this.dialogRef.close({ acknowledged: true });
    }
  }

  private formatTimestamp(): string {
    const now = new Date();
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZoneName: "shortOffset",
    };
    return now.toLocaleString("en-US", options);
  }

  private updateTimestamp(): void {
    this.currentTimestamp = this.formatTimestamp();
  }
}
